import { Record, List, fromJS } from 'immutable';
import _ from 'lodash';

import { AmountCurrencies } from 'utils/currencyFormat';

interface CapGroup {
  criteria: Record<string, unknown>;
  limitPerUser: number;
}

const properties = {
  id: '',
  createdAt: new Date(),
  startingAt: new Date(),
  endingAt: new Date(),
  title: '',
  limitPerUser: undefined,
  limitTotal: undefined,
  currencyCode: 'USD',
  limitToCurrency: false,
  locationsExclude: true,
  locations: List(),
  _matchedAmountCurrencies: undefined,
  capGroups: List(),
  limitAssertionType: '',
  givingAccount: undefined,
};

export default class Budget extends Record(properties, 'Budget') {
  public readonly id!: string;

  public readonly createdAt!: Date;

  public readonly startingAt!: Date;

  public readonly endingAt!: Date;

  public readonly title!: string;

  public readonly limitPerUser!: number;

  public readonly limitTotal!: number;

  public readonly currencyCode!: string;

  public readonly limitToCurrency!: boolean;

  public readonly locationExclude!: boolean;

  public readonly locations!: List<any>;

  public readonly _matchedAmountCurrencies!: AmountCurrencies;

  public readonly capGroups!: List<CapGroup>;

  public readonly limitAssertionType!: string;

  public readonly givingAccount!: string;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      createdAt: values.createdAt ? new Date(values.createdAt) : undefined,
      startingAt: values.startingAt ? new Date(values.startingAt) : undefined,
      endingAt: values.endingAt ? new Date(values.endingAt) : undefined,
      locations: List(values.locations || []),
      capGroups: fromJS(values.capGroups || []),
    });
  }
}
